import { Component, OnInit } from '@angular/core';
import { fontSize_opentab } from './ops-contractor-head-count.config';
import { Priority } from '@constants/global.enum';
import { Router } from '@angular/router';
import { VendorService } from '@app/shared/services/vendor.service';
import { PageTitle, ContractorHeadCountLabels } from '@app/shared/constants/global.enum';

@Component({
  selector: 'app-ops-contractor-head-count',
  templateUrl: './ops-contractor-head-count.component.html',
  styleUrl: './ops-contractor-head-count.component.scss',
})
export class OpsContractorHeadCountComponent implements OnInit {
  month: Array<{ label: string; value: number; selected?: boolean }> = [];
  selectedMonth: number = 0;
  totalContractor: number = 0;
  contractorOnBoarded: number = 0;
  contractorOffBoarded: number = 0;
  priority = Priority;
  fontSize_opentab = fontSize_opentab;
  employeeId: string = '';
  pageTitle = PageTitle.ContractorHeadcount;
  total = ContractorHeadCountLabels.Total;
  onBoarded = ContractorHeadCountLabels.OnBoarded;
  offBoarded = ContractorHeadCountLabels.OffBoarded;
  contractors= ContractorHeadCountLabels.Contractors;

  constructor(
    private router: Router,
    private vendorService: VendorService,
  ) {}

  async ngOnInit() {
    this.generateLast12Months();
    const now = new Date();
    const currentMonthLabel = now.toLocaleString('default', {
      month: 'long',
      year: 'numeric',
    });
    const currentMonthOption = this.month.find(
      (option) => option.label === currentMonthLabel,
    );
    if (currentMonthOption) {
      this.selectedMonth = currentMonthOption.value;
    }
    this.fetchContractorHeadCount(this.selectedMonth);
  }

  generateLast12Months() {
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - i);
      const monthLabel = monthDate.toLocaleString('default', {
        month: 'long',
        year: 'numeric',
      });
      const monthValue = monthDate.getMonth() + 1;
      this.month.push({
        label: monthLabel,
        value: monthValue,
        selected: i == 0,
      });
    }
  }

  fetchContractorHeadCount(month: number, year?: number) {
    const selectedYear = year ?? new Date().getFullYear();
    this.vendorService.getOpsContractorsCount(month, selectedYear).subscribe({
      next: (response: any) => {
        if (
          response &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          const data = response.data[0];
          this.totalContractor = data.totalContractors ?? 0;
          this.contractorOnBoarded = data.onBoardedContractors ?? 0;
          this.contractorOffBoarded = data.offBoardedContractors ?? 0;
        } else {
          this.resetHeadCount();
        }
      },
      error: () => {
        this.resetHeadCount();
      },
    });
  }

  private resetHeadCount() {
    this.totalContractor = 0;
    this.contractorOnBoarded = 0;
    this.contractorOffBoarded = 0;
  }

  valueSelect(event: any) {
    let selectedValue: number | undefined;
    let selectedYear: number | undefined;
    if (typeof event === 'string') {
      const monthOption = this.month.find((option) => option.label === event);
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }
    if (selectedValue && this.month.some((option) => option.value === selectedValue)) {
      this.selectedMonth = Number(selectedValue);
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
      selectedYear = (this.selectedMonth > currentMonth) ? currentYear - 1 : currentYear;
      this.fetchContractorHeadCount(this.selectedMonth, selectedYear);
    }
    else {
      this.resetHeadCount();

    }

  }

  navigateToContractorsList(): void {
    const selectedMonthOption = this.month.find((option) => option.value === this.selectedMonth);
    const month = selectedMonthOption ? this.selectedMonth : new Date().getMonth() + 1;
    const year = selectedMonthOption ? Number(selectedMonthOption.label.split(' ')[1]) : new Date().getFullYear();

    this.router.navigate(['/ops-vendor-management/contractors-list'], {
      queryParams: { month, year },
    });
  }
}
